import { createContext, useContext, useMemo, useState } from "react";

const LiveWorkspaceCreationContext = createContext();

export const useLiveWorkspaceCreationContext = () => {
  const context = useContext(LiveWorkspaceCreationContext);
  if (context === undefined) throw new Error("useLiveWorkspaceCreationContext must be used within a LiveWorkspaceCreationProvider");
  return context;
};

export const LiveWorkspaceCreationProvider = ({ children }) => {
  const [selectedCourses, setSelectedCourses] = useState([]);

  const [meetingList, setMeetingList] = useState([]);
  const [courseList, setCourseList] = useState([]);

  const [workspaceTitle, setWorkspaceTitle] = useState("");
  const [workspaceDesc, setWorkspaceDesc] = useState("");
  const [creating, setCreating] = useState(false);

  const valueToProvide = useMemo(
    () => ({
      selectedCourses,
      setSelectedCourses,
      meetingList,
      setMeetingList,
      courseList,
      setCourseList,
      workspaceTitle,
      setWorkspaceTitle,
      workspaceDesc,
      setWorkspaceDesc,
      creating,
      setCreating,
    }),
    [selectedCourses, meetingList, courseList, workspaceTitle, workspaceDesc, creating],
  );

  return <LiveWorkspaceCreationContext.Provider value={valueToProvide}>{children}</LiveWorkspaceCreationContext.Provider>;
};
